import api from './axios';

export const listar = () => api.get('/usuarios/');
export const criar = (data) => api.post('/usuarios/', data);
export const atualizar = (idUsuarioPortal, data) => api.patch(`/usuarios/${idUsuarioPortal}`, data);
export const resetarSenha = (idUsuarioPortal, novaSenha) =>
  api.patch(`/usuarios/${idUsuarioPortal}/resetar-senha`, { nova_senha: novaSenha });
